
import React from "react";
import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { Bell } from "lucide-react";
import { SubscriptionWall } from "@/components/subscription/SubscriptionWall";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        // For feedback notifications, wrap Bell icon in SubscriptionWall
        const isFeedbackNotification = props.variant !== "destructive" && props.className?.includes("feedback-notification");
        
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && (
                <ToastTitle className="flex items-center gap-2">
                  {isFeedbackNotification && (
                    <SubscriptionWall fallback={null}>
                      <Bell className="h-4 w-4 text-blue-500" />
                    </SubscriptionWall>
                  )}
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}

export default Toaster;
